<template>
  <div class="import-team">
    <el-dialog :visible="true" width="40%" :before-close="closeUpload">
      <el-upload
        class="upload-demo"
        drag
        action=""
        :http-request="importTeam"
        :show-file-list="false"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>

      <div class="success">
        <div v-for="(file, index) in uploadList" :key="index">
          <div>{{ file }}</div>
          <div><span></span>100%</div>
        </div>
      </div>

      <el-button size="small" @click="closeUpload">取消</el-button>
    </el-dialog>
  </div>
</template>
<script>
import * as API from "@/api/season";

export default {
  props: ["handleClose"],
  data() {
    return {
      uploadList: [],
    };
  },
  methods: {
    async importTeam(file) {
      const formData = new FormData();
      formData.append("file", file.file);
      try {
        const res = await API.importTeam(formData);
        const { code } = res;
        if (code === 0) {
          if (file.file?.name) this.uploadList.push(file.file?.name);
        }
      } catch (error) {
        //防止request返回reject
      }
    },
    closeUpload() {
      this.handleClose(Boolean(this.uploadList.length));
    },
  },
};
</script>
<style scoped lang="scss">
.import-team {
  text-align: center;
  .success {
    margin-bottom: 20px;
    > div {
      text-align: left;
      padding-left: 20px;
      > div:first-child {
        color: rgba(16, 16, 16, 100);
        font-size: 14px;
        line-height: 24px;
      }
      > div:last-child {
        color: rgba(79, 204, 14, 100);
        font-size: 14px;
        > span {
          display: inline-block;
          width: 80%;
          margin-right: 20px;
          border-bottom: 2px solid rgba(27, 244, 55, 100);
        }
      }
    }
  }
}
</style>
